import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ProjectsActions } from 'redux/actions';
import { Container, FormWrapper, SecondaryButton } from 'utils';
import styled from '@emotion/styled';
import { Form } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { ArrowLeftOutlined } from '@ant-design/icons';
import {
  IconKapital,
  IconPersonen,
  IconPrivatperson,
  IconVerein,
} from 'images';

const ClickableFormItem = styled(FormItem)`
  cursor: pointer;
  background-color: ${({ $isSelected }) =>
    $isSelected ? '#f5f5f5' : 'transparent'};
  transition: background-color 0.3s ease;
  flex-direction: row !important; /* Force horizontal layout */
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px;

  &:hover {
    border-radius: 10px;
    background-color: #f0f0f0;
  }

  .ant-form-item-control-input {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    width: 100%;
  }

  .ant-form-item-control-input-content {
    display: flex;
    flex-direction: row !important;
    align-items: center;
    width: 100%;
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  margin-right: 12px;
  flex-shrink: 0;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

const Description = styled.p`
  margin: 5px 0 0;
  font-size: 14px !important;
  color: #666;
  padding-bottom: 0 !important;
`;

export class StripeAccount extends Component {
  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    setCanMove: PropTypes.func.isRequired,
    currentStep: PropTypes.number.isRequired,
  };
  //componentDidMount() {
  //  const { projectId, getStripeStatus } = this.props;
  //  getStripeStatus(projectId);
  //}
  onFinish = (value) => {
    const parsedValue = { business_type: value.id };
    const { setCanMove, projectId, updateDraft, currentStep } = this.props;
    setCanMove(true);
    console.log('pressed', parsedValue);
    if (projectId) {
      updateDraft(projectId, parsedValue, currentStep);
      sessionStorage.removeItem('userType');
    } else {
      sessionStorage.setItem('userType', JSON.stringify(parsedValue));
    }
    this.props.handleSteps(3);
  };

  onReturn = () => {
    this.props.handleSteps(1);
  };

  render() {
    const { project } = this.props;

    const savedData = sessionStorage.getItem('userType');
    const parsedData = savedData ? JSON.parse(savedData) : {};

    const savedCategory = sessionStorage.getItem('categoryType');
    const parsedCategory = savedCategory ? JSON.parse(savedCategory) : {};

    const selectedCountry =
      project && project?.categoryType && project?.categoryType?.country
        ? project?.categoryType?.country
        : parsedCategory.country;
    const isGermany = selectedCountry === 'DE' ? true : false;

    const entityTypes = [
      {
        id: 'individual',
        title: 'Privatperson',
        description:
          'Das gilt auch für e.K., Kleingewerbetreibende & Freiberufler',
        icon: <img src={IconPrivatperson} alt="Icon Privatperson" />,
      },
      {
        id: 'non_profit',
        title: 'Verein oder Genossenschaft',
        description: null,
        icon: <img src={IconVerein} alt="Icon verein" />,
      },
      {
        id: 'company',
        title: 'Kapitalgesellschaft',
        description: 'Dies gilt für GmbH, UG und AG',
        icon: <img src={IconKapital} alt="Icon Kapitalgesellschaft." />,
      },
      {
        id: 'government_entity',
        title: 'Personengesellschaft',
        description:
          'Dies gilt beispielsweise für GbR, OHG, KG, PartG, GmbH & Co, KG',
        icon: <img src={IconPersonen} alt="Icon Personengesellschaft" />,
      },
    ];

    return (
      <Container className="inside-form-container">
        <Form onFinish={this.onFinish}>
          <h1>Ich starte ein Projekt als...</h1>
          <FormWrapper>
            {entityTypes.map((type) => (
              <>
                {!(!isGermany && type.id === 'government_entity') && (
                  <ClickableFormItem
                    key={type.title}
                    onClick={() => {
                      this.onFinish(type);
                    }}
                    $isSelected={
                      type.id ===
                      ((
                        project && project?.business_type
                          ? project.business_type
                          : parsedData
                      )
                        ? 'true'
                        : undefined)
                    }
                  >
                    <IconContainer>{type.icon}</IconContainer>
                    <TextContainer>
                      <Title>{type.title}</Title>
                      {type.description && (
                        <Description>{type.description}</Description>
                      )}
                    </TextContainer>
                  </ClickableFormItem>
                )}
              </>
            ))}

            <p>
              <b>Ticketprojekt?</b> Kein Problem! Erstelle einfach ein ganz
              normales Projekt und gib uns danach über das{' '}
              <a
                href="#"
                style={{
                  color: '#3F621A',
                  textDecoration: 'underline',
                }}
              >
                Kontaktformular
              </a>{' '}
              Bescheid.
            </p>

            <FormItem>
              <SecondaryButton
                type="button"
                minWidth="120px"
                onClick={this.onReturn}
              >
                <>
                  <ArrowLeftOutlined />
                  <p>Zurück</p>
                </>
              </SecondaryButton>
            </FormItem>
          </FormWrapper>
        </Form>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, currentStep } = state.projects;
  return {
    project,
    currentStep,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StripeAccount);
